import { ReactNode } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog'
import { ScrollArea } from '@/components/ui/scroll-area'
import { cn } from '@/lib/utils'

interface StandardDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string | ReactNode
  description?: string | ReactNode
  children: ReactNode
  footer?: ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full'
  className?: string
  contentClassName?: string
  scrollable?: boolean
  showCloseButton?: boolean
}

export function StandardDialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  size = 'md',
  className,
  contentClassName,
  scrollable = true,
  showCloseButton = true,
}: StandardDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        size={size}
        showCloseButton={showCloseButton}
        className={className}
      >
        {/* Fixed Header */}
        {(title || description) && (
          <DialogHeader className="flex-shrink-0 pb-4">
            {title && (
              <DialogTitle className="text-left">
                {typeof title === 'string' ? title : title}
              </DialogTitle>
            )}
            {description && (
              <DialogDescription className="text-left">
                {typeof description === 'string' ? description : description}
              </DialogDescription>
            )}
          </DialogHeader>
        )}

        {/* Scrollable Content */}
        <div className={cn('flex-1 min-h-0', scrollable ? 'overflow-auto' : 'overflow-hidden')}>
          {scrollable ? (
            <div className={cn('h-full overflow-auto p-1 -mr-1', contentClassName)}>
              <div className="pr-3">
                {children}
              </div>
            </div>
          ) : (
            <div className={cn('h-full flex flex-col', contentClassName)}>
              {children}
            </div>
          )}
        </div>

        {/* Fixed Footer */}
        {footer && (
          <DialogFooter className="flex-shrink-0 pt-4 border-t">
            {footer}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  )
}